import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { routes } from "consts";
import React from "react";

import { useNavigate } from "react-router-dom";
import { UserForm, UserFormValues } from "./UserForm/UserForm";
import { getApiErrorMessage, useToaster } from "utils";
import axios from "axios";
import { studentsApi } from "api/studentsApi";

export const AddUserPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const breadcrumbs = [{ title: "Użytkownicy", path: routes.STUDENTS }, { title: "Dodawanie użytkownika" }];

  const onSubmit = async (data: UserFormValues) => {
    try {
      await studentsApi.create(data);
      navigate(routes.STUDENTS);
      showSuccess("Użytkownik został dodany.");
    } catch (e) {
      console.error(e);
      // ResourceNotUniqueException (ARNU601) is the only "not unique" create can answer: the email is taken.
      const taken = axios.isAxiosError(e) && e.response?.data?.type === "ARNU601";
      showError(
        taken
          ? "Użytkownik z tym adresem email już istnieje."
          : getApiErrorMessage(e, "Nie udało się dodać użytkownika."),
      );
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Dodaj użytkownika" />
      <UserForm onSubmit={onSubmit} />
    </PageMain>
  );
};
